import { render, staticRenderFns } from "./Tradingview.vue?vue&type=template&id=fae4a73c&scoped=true"
import script from "./Tradingview.vue?vue&type=script&lang=js"
export * from "./Tradingview.vue?vue&type=script&lang=js"
import style0 from "./Tradingview.vue?vue&type=style&index=0&id=fae4a73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae4a73c",
  null
  
)

export default component.exports